import { Component, EventEmitter, Input, Output } from '@angular/core';

interface Person {
  name: string;
  email: string;
  notificationType: string;
}

@Component({
    selector: 'app-dynamic-person-to-notify',
    templateUrl: './dynamic-person-to-notify.component.html',
    styleUrls: ['./dynamic-person-to-notify.component.scss'],
    standalone: false
})
export class DynamicPersonToNotifyComponent {
  @Output() personData = new EventEmitter<string[]>();
  @Input() title: string;
  @Input() label: string;
  @Input() typeOfLegacy: string;

  peopleToNotify: Person[];
  doNotAddAnotherPerson: boolean;

  constructor() { }

  ngOnInit() {
    switch (this.typeOfLegacy) {
      case 'Facebook':
        this.doNotAddAnotherPerson = true;
        this.peopleToNotify = [{ name: '', email: '', notificationType: 'Yes' }];
        break;
      case 'Apple':
        this.doNotAddAnotherPerson = false;
        this.peopleToNotify = [{ name: '', email: '', notificationType: 'Yes' }];
        break;
      case 'Google':
        this.doNotAddAnotherPerson = false;
        this.peopleToNotify = [{ name: '', email: '', notificationType: 'All' }];
        break;
    }
  }

  addPerson() {
    if (this.typeOfLegacy === 'Facebook' || this.typeOfLegacy === 'Apple') {
      this.peopleToNotify.push({ name: '', email: '', notificationType: 'Yes' });
    }
    else {
      this.peopleToNotify.push({ name: '', email: '', notificationType: 'All' });
    }
  }

  removePerson(index: number) {
    this.peopleToNotify.splice(index, 1);
    this.savePersonChanges();
  }

  savePersonChanges() {
    const peopleStrings = this.peopleToNotify.map(person => `${person.name} | ${person.email} | ${person.notificationType}`);
    this.personData.emit(peopleStrings);
  }
}
